export default "__VITE_PUBLIC_ASSET__48db1f22__"